import { Button } from "@synthesis/shared-ui";
import IconPencil from "@synthesis/shared-icons/IconPencil";

import { UserInfoFieldsGrid, type UserInfoField } from "./user-info-fields-grid";

type UserInfoSectionProps = {
  title: string;
  description?: string;
  fields: UserInfoField[];
  withEditButton?: boolean;
  onEditClick?: () => void;
};

export const UserInfoSection = ({ title, description, fields, withEditButton = false, onEditClick }: UserInfoSectionProps) => (
  <section className="flex flex-col">
    <div className="mb-4 flex items-start justify-between gap-4">
      <div className="flex min-w-0 flex-col gap-1">
        <h2 className="paragraph-lg text-type-common">{title}</h2>
        {description ? <p className="subtitle-sm text-type-minor">{description}</p> : null}
      </div>
      {withEditButton ? (
        <Button type="button" theme="text" size="sm" className="shrink-0" leftIcon={<IconPencil className="size-5" />} onClick={onEditClick}>
          Изменить
        </Button>
      ) : null}
    </div>
    <UserInfoFieldsGrid fields={fields} />
  </section>
);
